import React, { useState, useEffect } from "react";
import { getInfo, logout } from "../other/user_info";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setH24 } from "../actions/h24";
import {
  Box,
  Typography,
  IconButton,
  Checkbox,
  Grid,
  Paper,
  FormControlLabel,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LogoutIcon from "@mui/icons-material/Logout";

const AccountInfo = () => {
  const [style, setStyle] = useState();
  const info = getInfo();
  const history = useHistory();
  const dispatch = useDispatch();
  const h24 = useSelector((state) => state.h24);

  useEffect(() => {
    setTimeout(() => {
      setStyle("nav-active");
      document.getElementById("info-back").focus();
    }, 10);
  }, []);

  const back = () => {
    setStyle();
    setTimeout(() => {
      history.goBack();
    }, 600);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#212529",
        padding: 2,
      }}
    >
      <Paper
        elevation={8}
        sx={{
          padding: 3,
          maxWidth: 400,
          width: "100%",
          backgroundColor: "#282c34",
          color: "white",
          borderRadius: 2,
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <IconButton onClick={back} sx={{ color: "white" }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" align="center">
            Account Info
          </Typography>
          <IconButton onClick={logout} sx={{ color: "white" }}>
            <LogoutIcon />
          </IconButton>
        </Box>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography variant="body1">Username: {info.username}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1">Password: {info.password}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1">
              Max Connections: {info.max_connections}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1">
              Expire On: {info.expiry.toGMTString()}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">{info.message}</Typography>
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={h24 === "HH:MM"}
                  onChange={() => dispatch(setH24(h24 !== "HH:MM"))}
                  sx={{ color: "white" }}
                />
              }
              label="Use 24H format"
              sx={{ color: "white", fontSize: "0.875rem" }}
            />
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default AccountInfo;
